import React, { useEffect } from 'react'
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import { LinearProgress } from '@mui/material';

const RecentDocuments = (props) => {

  //#region props
  const { recentDocuments } = props;

  //#region return
  return (
    <div className='white-card child-margin-10 height-400'>
        <div className='grid-header'>Recent Analysis</div>
        {
          recentDocuments
          ?  <div className='child-margin-15'>
                {
                    recentDocuments?.map((doc, index) => (
                        <div key={index} className='recent-document-item'>
                          <div className='recent-document-icon'>
                            <TextSnippetIcon color='' sx={{ width: '48px',height: '48px' }} />
                          </div>
                          <div className='recent-document-content'>
                            <div className='recent-document-title'>{doc.uploadedDocmentName}</div>
                            <div className='recent-document-author'>{doc.createdUserName}</div>
                          </div>
                          <div>
                            <span className='recent-document-status'>✓ analyzed</span>
                           {/*  <div className='recent-document-insights'>31 insights</div> */}
                          </div>
                        </div>
                    ))
                }
            </div>
          : <div className='child-margin-15'>
              <LinearProgress />
            </div>
        }
        
    </div>
  )
}

export default RecentDocuments